import React from 'react';
import "./Sidebar.css";
import { Avatar } from "@mui/material";
import { selectUser } from './features/userSlice'
import { useSelector } from 'react-redux'

function Sidebar () {
    const user = useSelector(selectUser);

    const recentItem = (topic) => (
        <div className='sidebar__recentItem'>
            <span className='sidebar__hash'>#</span>
            <p>{topic}</p>
        </div>
    )
 
  return ( 
    <div className='sidebar'>
        <div className='sidebar__top'>
            <img 
                src="https://media.istockphoto.com/id/1378069432/photo/abstract-pastel-colored-sky-background.jpg?b=1&s=170667a&w=0&k=20&c=ogOe2GOvuH6IF10W0t-r4Ay5pbvPUNOmreNiAiSgDHw=" 
                alt=""
            />
            <Avatar src={user.photoUrl} className='sidebar__avatar'>{user.email[0]}</Avatar>
            <h2>{user.displayName}</h2>
            <h4>{user.email}</h4>
        </div>
        <div className='sidebar__stats'>
            <div className='sidebar__stat'>
                <p>Who viewed you</p>
                <p className='sidebar__statNumber'>9,132</p>
            </div>
            <div className='sidebar__stat'>
                <p>Views on posts</p>
                <p className='sidebar__statNumber'>132</p>
            </div>
        </div>

        <div className='sidebar__bottom'>
            <p>Recent</p>
            {recentItem('reactjs')}
            {recentItem('figma')}
            {recentItem('nextjs')}
            {recentItem('softwareengineering')}
            {recentItem('development')}
        </div>
  </div>
  );
}

export default Sidebar